module.exports = __webpack_public_path__ + "static/media/chubb_garnetek_seguro_telefonos_moviles.b4695727.pdf";